/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".me-fullscreen[_ngcontent-%COMP%]{-webkit-transform:translateY(0);transform:translateY(0)}.finder-syndicated-header-wrapper[_ngcontent-%COMP%]{margin-top:0;transition:margin-top .5s ease-in;position:relative;z-index:1}.fullscreen[_nghost-%COMP%], .fullscreen   [_nghost-%COMP%]{-webkit-transform:translateY(0);transform:translateY(0)}.fullscreen[_nghost-%COMP%]   .finder-syndicated-header-wrapper[_ngcontent-%COMP%], .fullscreen   [_nghost-%COMP%]   .finder-syndicated-header-wrapper[_ngcontent-%COMP%]{margin-top:-72px}"];
export { styles as styles };
